<p-dialog
  header="ERA SME Notification"
  [modal]="true"
  [(visible)]="visible"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '48rem' }"
  styleClass="sme-notification-dialog"
  (onHide)="close()">

  <p-messages></p-messages>

  <div class="notification-form">
    <div class="field-group">
      <label for="sme-recipients">Send to</label>
      <p-autoComplete
        inputId="sme-recipients"
        placeholder="Add SME recipients"
        [(ngModel)]="selectedRecipients"
        [suggestions]="suggestions"
        [multiple]="true"
        [minLength]="2"
        [delay]="300"
        field="displayName"
        (completeMethod)="searchUsers($event)">
        <ng-template let-user pTemplate="item">
          <div class="sme-user-option">
            <span class="sme-user-name">{{ user.displayName }}</span>
            <span class="sme-user-mail">{{ user.mail }}</span>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>

    <div class="field-group">
      <label for="sme-notes">Notes</label>
      <textarea
        id="sme-notes"
        rows="5"
        pInputTextarea
        [(ngModel)]="notes"
        [autoResize]="true"
        placeholder="Add a note for the SME review..."></textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="sme-footer">
      <sme-status-section
        [projectPk]="selectedProject?.projectPk"
        (statusesChange)="stepStatuses = $event"></sme-status-section>
      <button
        pButton
        type="button"
        [label]="sending ? 'Sending...' : 'Send'"
        [icon]="sending ? 'pi pi-spin pi-spinner' : 'pi pi-send'"
        [disabled]="isSendDisabled"
        (click)="send()"></button>
    </div>
  </ng-template>
</p-dialog>
